<template>
  <div class="card">
    <span
      :style="{
        color: titleColor,
        'text-align': 'center',
        'font-weight': 600,
        'font-size': '17px'
      }"
    >
      {{ title }}
    </span>
    <div
      :style="{
        overflowX: model.xAxis.length > 7 ? 'auto' : 'hidden'
      }"
      class="scroll"
    >
      <v-chart
        :key="dynamicMinWidth"
        :option="chartOptions"
        :style="{ minWidth: dynamicMinWidth, height: '100%' }"
      ></v-chart>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  name: "BarEChart",
  props: {
    title: String,
    model: Object
  },
  computed: {
    chartOptions() {
      return {
        grid: {
          top: 20,
          right: 30,
          bottom: 50,
          left: 30
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
            const data = params[0];
            const label = data.name;
            const value = data.value;
            const formattedValue = value
              .toFixed(2)
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            const formattedValueStr =
              this.barType === "economy"
                ? `R$ ${formattedValue}`
                : formattedValue;
            return `${label}: ${formattedValueStr}`;
          }.bind(this)
        },
        xAxis: {
          type: "category",
          data: this.model.xAxis,
          scale: true,
          axisLabel: {
            rotate: 0,
            color: this.titleColor,
            formatter: value => {
              const parts = value.split(" ");
              if (parts.length > 1) {
                return `${parts[0]}\n${parts.slice(1).join(" ")}`;
              }
              return value;
            },
            overflow: "truncate"
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: this.model.data,
            type: "bar",
            label: {
              show: true,
              position: "inside",
              color: "white",
              textBorderColor: "#000000",
              textBorderWidth: 2,
              formatter: params => {
                const value = params.value;

                const formattedValue = value
                  .toFixed(2)
                  .replace(".", ",")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                return this.barType === "economy"
                  ? `R$ ${formattedValue}`
                  : formattedValue;
              }
            }
          }
        ]
      };
    },
    titleColor() {
      return this.$store.state.darkmode ? "white" : "black";
    },
    dynamicMinWidth() {
      if (this.model.xAxis.length <= 7) {
        return "100%";
      }
      const baseWidth = 600;
      const extraWidth = 20;
      const extraCategories = this.model.xAxis.length - 25;
      return extraCategories > 0
        ? `${baseWidth + extraCategories * extraWidth}px`
        : `${baseWidth}px`;
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  height: 370px;
  padding: 20px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  margin-bottom: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  border-color: #ffffff;
  border: 1px solid;
  display: flex;
  justify-content: center;
}

.scroll {
  width: 100%;
  height: 445px;
}
</style>
